import { useRef, useEffect } from "preact/hooks";
import type { Action, AppState } from "../state/actions.ts";

interface Props {
  html: string;
  style: AppState["textStyle"];
  isActive: boolean;
  dispatch: (action: Action) => void;
}

export function TextOverlay({ html, style, isActive, dispatch }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== html) {
      ref.current.innerHTML = html;
    }
  }, [html]);

  return (
    <div
      ref={ref}
      contentEditable={isActive}
      class="absolute z-20 outline-none overflow-auto"
      style={{
        top: 60,
        left: 70,
        right: 70,
        bottom: 40,
        fontFamily: style.fontFamily,
        fontSize: `${style.fontSize}px`,
        fontWeight: style.fontWeight ?? "normal",
        color: style.color,
        lineHeight: style.lineHeight,
        textTransform: "uppercase",
        pointerEvents: isActive ? "auto" : "none",
        border: "1px dashed transparent",
        padding: "4px",
        background: "transparent",
      }}
      onInput={() => {
        if (ref.current) dispatch({ type: "SET_TEXT_HTML", html: ref.current.innerHTML });
      }}
    />
  );
}
